import * as t from 'io-ts';

import {makeApiType, makeEnumRuntimeType, RContactUidRef} from './apiTypes';
import {buildContactUid, parseContactSource, parseContactUid} from './contactModel';

/*
 * Runtime type.
 */

export enum RecipientRolesEnum {
  FROM = 'from',
  TO = 'to',
  CC = 'cc',
  BCC = 'bcc',
  REPLY_TO = 'reply-to',
  MENTION = 'mention',
}

const requiredProperties = t.type({
  contactUid: RContactUidRef,
  role: makeEnumRuntimeType(RecipientRolesEnum),
});

const optionalProperties = t.partial({
  url: t.string,
  name: t.string,
  handle: t.string,
  isSpammer: t.boolean,
});

const RRecipientDirty = t.readonly(t.intersection([requiredProperties, optionalProperties]));

/*
 * Type.
 */

export interface RecipientModel extends t.TypeOf<typeof RRecipientDirty> {}
export const RRecipient = t.clean<RecipientModel>(RRecipientDirty as any);

/*
 * IO methods.
 */

export function parseRecipient(src: any): RecipientModel {
  // FIXME: some (old) contacts have lost their handle in the DB. We do this to avoid crashing.
  const handle = src.handle || 'noemail@frontapp.com';
  const source = parseContactSource(src.source);

  return {
    contactUid: buildContactUid(source, handle),
    role: src.role,
    url: src.recipient_url || undefined,
    name: (src.name && src.name.trim()) || undefined,
    handle,
    isSpammer: Boolean(src.is_spammer),
  };
}

export function serializeRecipient(recipient: RecipientModel) {
  const [, handle] = parseContactUid(recipient.contactUid);
  return {
    role: recipient.role,
    name: recipient.name,
    handle,
  };
}

/*
 * API type.
 */

export const ApiRecipient = makeApiType('recipient', RRecipient, parseRecipient);
